import styled from 'styled-components';

export const PhoneWrapper = styled.section`
    background: linear-gradient(180deg, var(--color-background) 25%, var(--color-surface) 25%, var(--color-surface) 75%, var(--color-background) 75%);

    img {
        width: 100%;
    }
`;